import { render, staticRenderFns } from "./UserWelcomeEmailView.vue?vue&type=template&id=6535f5dc"
import script from "./UserWelcomeEmailView.vue?vue&type=script&lang=js"
export * from "./UserWelcomeEmailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports